import React from "react";
import classNames from "classnames";

import styles from "./LikeButton.module.scss";
import LikeIcon from "../../icons/innerPageIcons/like";
import { setLoginModal } from "../../../store/slices/modals.slice";
import { useDispatch } from "react-redux";

type Direction = "column" | "row";

interface ILikeButtonProps {
  isMobile: boolean;
  direction: Direction;
  className?: string;
  count?: number;
  clickHandler: (e: any, item: any, liked: boolean) => void;
  updateFieldLocal: (id: any, item: any, field: any) => void;
  liked: boolean;
  item: any;
}

const LikeButton = ({
  isMobile,
  direction,
  className,
  count,
  clickHandler,
  liked,
  updateFieldLocal,
  item,
}: ILikeButtonProps) => {
  const dispatch = useDispatch();
  const wrapperMods = classNames(styles.likesWrapper, className, {
    [styles.likesWrapperRow]: direction === "row",
    [styles.likesWrapperColumn]: direction === "column",
  });

  return (
    <div
      className={wrapperMods}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        const token = localStorage.getItem("accessToken");
        if (!token) {
          dispatch(setLoginModal(true));
          return;
        }

        updateFieldLocal(item.id, "vote_count", liked ? "decrement" : "increment");
        clickHandler(e, item, liked);
      }}
    >
      <LikeIcon className={`${isMobile ? styles.likeIcon : styles.likeIconDesctop} ${liked ? styles.likedIcon : ""}`} />
      <p className={styles.counter}>{count}</p>
    </div>
  );
};

export default LikeButton;
